import { render } from "./verifyPhoneModal.vue?vue&type=template&id=e7a4e658&scoped=true"
import script from "./verifyPhoneModal.vue?vue&type=script&lang=js"
export * from "./verifyPhoneModal.vue?vue&type=script&lang=js"

import "./verifyPhoneModal.vue?vue&type=style&index=0&id=e7a4e658&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7a4e658"]])

export default __exports__